import React from 'react';
import styled, { css } from 'styled-components';
import { Done } from '@lt/components/icons-react';

export interface HintItem {
  name: string;
  checked: boolean;
}

interface Props {
  className?: string;
  items: HintItem[];
}

export const PasswordHint: React.FC<Props> = ({ items, className }) => (
  <Container className={className}>
    {items.map((item) => (
      <Item key={item.name}>
        {item.checked && <Done width={16} />}
        <ItemText active={item.checked}>{item.name}</ItemText>
      </Item>
    ))}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;

  :not(:first-child) {
    margin-left: 11px;
  }

  path {
    stroke: #6abf40;
  }
`;

const ItemText = styled.span<{ active?: boolean }>`
  margin-left: ${({ active }) => (active ? 5 : 16)}px;
  color: ${({ active }) => (active ? '#17181A' : '#4D4D4D')};

  ${({ active }) =>
    !active &&
    css`
      position: relative;

      &::before {
        content: '';
        position: absolute;
        bottom: 6px;
        left: -12px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #c2c5cc;
      }
    `};
`;
